import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "checkout-order-summary",
  class: "order-summary"
};
const _hoisted_2 = {
  class: "order-summary-title"
};
const _hoisted_3 = {
  class: "order-summary-multiple-po"
};
const _hoisted_4 = {
  class: "order-summary-multiple-po-title"
};
const _hoisted_5 = {
  key: 0,
  class: "order-summary-tax-message"
};
const _hoisted_6 = {
  key: 1,
  class: "order-summary-tax-message"
};
const _hoisted_7 = {
  class: "order-summary-checkout-info checkout-review"
};
const _hoisted_8 = {
  class: "order-summary-buttons checkout-btns"
};
const _hoisted_9 = ["aria-label", "disabled", "value"];
const _hoisted_10 = ["aria-label"];
const _hoisted_11 = ["aria-label"];
const _hoisted_12 = ["aria-label"];
const _hoisted_13 = ["aria-label"];
const _hoisted_14 = {
  class: "in-process-modal"
};
const _hoisted_15 = ["aria-label"];
const _hoisted_16 = {
  class: "in-process-body"
};
const _hoisted_17 = {
  class: "checkout-error-modal"
};
const _hoisted_18 = ["aria-label"];
const _hoisted_19 = {
  class: "error-body"
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = ["aria-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  const _component_PoSummaryItem = _resolveComponent("PoSummaryItem");
  const _component_DcModal = _resolveComponent("DcModal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_LoadingDots, {
    loading: $data.loading
  }, null, 8, ["loading"]), _createElementVNode("h4", _hoisted_2, _toDisplayString($options.getLabel('order.summary.Title')), 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString($options.getLabel('text.search.option.poNo')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.totalsByPo, (poEntry, index) => {
    return _openBlock(), _createBlock(_component_PoSummaryItem, {
      ref_for: true,
      ref: "PoItems",
      key: index,
      poData: poEntry,
      onResetToggle: $options.resetDropdowns
    }, null, 8, ["poData", "onResetToggle"]);
  }), 128))]), $options.isIndia ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($options.getLabel('cart.order.summary.message.checkout.india')), 1)) : _createCommentVNode("", true), $options.isExchangeMessage ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($options.getLabel('review.business.rules')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString($options.getLabel('reviewOrder.rightRail.des.text') + $options.getLabel('terms.conditions')), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", {
    class: "order-summary-buttons-cancel",
    tabindex: "0",
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers($event => $options.toggleCancelCheckoutModal(), ["prevent"]), ["enter"])),
    onClick: _cache[1] || (_cache[1] = $event => $options.toggleCancelCheckoutModal())
  }, _toDisplayString($options.getLabel('button.cancel.UPPER')), 33), _createElementVNode("input", {
    class: "order-summary-buttons-checkout approve-and-place",
    "aria-label": $options.getLabel('reviewOrder.rightRail.agree&PlaceOrderBtn'),
    type: "button",
    disabled: !$options.canCreateOrders,
    value: $options.getLabel('reviewOrder.rightRail.agree&PlaceOrderBtn'),
    onClick: _cache[2] || (_cache[2] = $event => $options.completeCheckout())
  }, null, 8, _hoisted_9)])])]), $data.showCancelCheckoutModal ? (_openBlock(), _createBlock(_component_DcModal, {
    key: 0,
    onModalClose: _cache[5] || (_cache[5] = $event => $options.toggleCancelCheckoutModal())
  }, {
    header: _withCtx(() => [_createElementVNode("h4", {
      class: "cancel-confirm-header",
      "aria-label": $options.getLabel('cancel.confirm.sure')
    }, _toDisplayString($options.getLabel('cancel.confirm.sure')), 9, _hoisted_10)]),
    body: _withCtx(() => [_createElementVNode("div", {
      class: "cancel-confirm-body",
      "aria-label": $options.getLabel('cart.page.cancelOrder.popup.message')
    }, [_createElementVNode("div", null, _toDisplayString($options.getLabel('cart.page.cancelOrder.popup.message')), 1)], 8, _hoisted_11)]),
    footer: _withCtx(() => [_createElementVNode("button", {
      class: "cancel-checkout-btn-no",
      "aria-label": $options.getLabel('button.no.UPPER'),
      onClick: _cache[3] || (_cache[3] = $event => $options.toggleCancelCheckoutModal())
    }, _toDisplayString($options.getLabel('button.no.UPPER')), 9, _hoisted_12), _createElementVNode("button", {
      class: "cancel-checkout-btn-yes",
      "aria-label": $options.getLabel('button.yes.UPPER'),
      onClick: _cache[4] || (_cache[4] = $event => $options.returnToCart())
    }, _toDisplayString($options.getLabel('button.yes.UPPER')), 9, _hoisted_13)]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [$data.showProcessingModal ? (_openBlock(), _createBlock(_component_DcModal, {
    key: 0
  }, {
    header: _withCtx(() => [_createElementVNode("h4", {
      class: "in-process-header",
      "aria-label": $options.getLabel('in.process.UPPER')
    }, _toDisplayString($options.getLabel('in.process.UPPER')), 9, _hoisted_15)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString($options.getLabel('order.processing.message')), 1)]),
    _: 1
  })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [$data.showErrorModal ? (_openBlock(), _createBlock(_component_DcModal, {
    key: 0,
    onModalClose: _cache[7] || (_cache[7] = $event => $options.toggleErrorModal())
  }, {
    header: _withCtx(() => [_createElementVNode("h4", {
      class: "error-header",
      "aria-label": $options.getLabel('error')
    }, _toDisplayString($options.getLabel('error')), 9, _hoisted_18)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", {
      innerHTML: $data.errorMessage
    }, null, 8, _hoisted_20)])]),
    footer: _withCtx(() => [_createElementVNode("button", {
      class: "error-modal-close",
      "aria-label": $options.getLabel('button.close.UPPER'),
      onClick: _cache[6] || (_cache[6] = $event => $options.toggleErrorModal())
    }, _toDisplayString($options.getLabel('button.close.UPPER')), 9, _hoisted_21)]),
    _: 1
  })) : _createCommentVNode("", true)])], 64);
}